import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
import { auth } from '@/firebaseConfig';
import App from './App.vue';
// import './registerServiceWorker';
import router from './router';
import store from './store';
import { User } from './types';

Vue.use(BootstrapVue);

Vue.config.productionTip = false;

let app: any = '';

auth.onAuthStateChanged(async currentUser => {
  if (currentUser) {
    const { claims } = await currentUser.getIdTokenResult(true);
    console.log('Claims', claims);
    if (!claims.role) {
      auth.signOut();
      return;
    }
    const user = {
      name: currentUser.displayName,
      email: currentUser.email,
      role: claims.role,
      companyId: claims.companyId,
    } as User;
    store.dispatch('setUser', user);
  }

  app = new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
});
